import React from 'react';
import { SectionCard, TextField, Repeater } from '../../../components/admin/EditorFields';

export default function NavigationEditor({ data, setData }) {
  const setItems = (items) => setData((d) => ({ ...d, menuItems: items }));

  return (
    <div className="space-y-5">
      <SectionCard
        title="Éléments du menu"
        description="Réorganisez avec les flèches haut/bas. Le lien doit être un chemin interne (ex: /blog) ou une URL externe. Ajoutez des sous-menus pour créer un dropdown au survol."
      >
        <Repeater
          items={data.menuItems}
          onChange={setItems}
          newItem={() => ({ label: 'Nouveau lien', to: '/', children: [] })}
          addLabel="Ajouter un lien"
          renderItem={(item, update) => (
            <div className="space-y-3">
              <div className="grid sm:grid-cols-2 gap-3">
                <TextField label="Libellé" value={item.label} onChange={(v) => update({ label: v })} />
                <TextField label="Lien" value={item.to} onChange={(v) => update({ to: v })} placeholder="/page ou https://..." />
              </div>

              {/* Sub-menu items */}
              <div className="pl-3 border-l-2 border-sky-100 space-y-2">
                <p className="text-xs font-semibold uppercase tracking-wider text-slate-500">
                  Sous-menu (optionnel — apparaît au survol sur desktop / clic sur mobile)
                </p>
                <Repeater
                  items={item.children || []}
                  onChange={(children) => update({ children })}
                  newItem={() => ({ label: '', to: '/' })}
                  addLabel="Ajouter un sous-lien"
                  renderItem={(child, updateChild) => (
                    <div className="grid sm:grid-cols-2 gap-3">
                      <TextField label="Libellé" value={child.label} onChange={(v) => updateChild({ label: v })} />
                      <TextField label="Lien" value={child.to} onChange={(v) => updateChild({ to: v })} placeholder="/sous-page" />
                    </div>
                  )}
                />
              </div>
            </div>
          )}
        />
      </SectionCard>

      <SectionCard title="Bouton d'appel à l'action (CTA)">
        <div className="grid sm:grid-cols-2 gap-3">
          <TextField label="Libellé du bouton" value={data.ctaLabel} onChange={(v) => setData((d) => ({ ...d, ctaLabel: v }))} />
          <TextField label="Lien du bouton" value={data.ctaLink} onChange={(v) => setData((d) => ({ ...d, ctaLink: v }))} />
        </div>
      </SectionCard>
    </div>
  );
}
